import { Injectable, InjectionToken } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IUsersService,
  User,
  UpdateUserPasswordParams,
  UpdateUserParams,
  UpdateUserStatusParams,
  CreateUserParams,
  FetchUsersParams,
} from './definitions';
import { environment } from '@env/environment';

export const UsersServiceToken = new InjectionToken<IUsersService>(
  'UsersService',
);

@Injectable({
  providedIn: 'root',
})
export class UsersService implements IUsersService {
  private baseUrl: string;

  public constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiUrl}/user`;
  }

  getUsers(params?: FetchUsersParams): Observable<User[]> {
    let url = `${this.baseUrl}/trustee`;

    if (params) {
      const { status = 'ALL' } = params;
      url = `${url}?status=${status}`;
    }

    return from(this.http.get<any>(url));
  }

  createUser(params: CreateUserParams): Observable<any> {
    const url = `${this.baseUrl}/trustee/create`;

    return this.http.post(url, params);
  }

  updateUser(params: UpdateUserParams): Observable<void> {
    const url = `${this.baseUrl}/details`;

    return this.http.put<void>(url, params);
  }

  updateUserPassword(params: UpdateUserPasswordParams): Observable<void> {
    const url = `${this.baseUrl}/change-password`;

    return this.http.post<void>(url, params);
  }

  enableUser(params: UpdateUserStatusParams): Observable<void> {
    const url = `${this.baseUrl}/status`;
    const data = {
      ...params,
      action: 'enable',
    };

    return this.http.put<void>(url, data);
  }

  disableUser(params: UpdateUserStatusParams): Observable<void> {
    const url = `${this.baseUrl}/status`;
    const data = {
      ...params,
      action: 'disable',
    };

    return this.http.put<void>(url, data);
  }
}
